import styled from 'styled-components';

export const WidgetWrapper = styled.div<{ padding: string }>`
  padding-bottom: ${({ padding }) => `${padding}px`};
`;
